import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, OwnerDescriptionResponseDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class FindByDescriptionVehicleOwnersCommand extends IRequestCommand<
  IFindByDescriptionVehicleOwnersResponse,
  ErrorDetails,
  IFindByDescriptionVehicleOwnersParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/vehicleOwners?description={description}';

  override setParameters(parameters: IFindByDescriptionVehicleOwnersParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{description}',
      parameters.description.toString()
    );
  }
}

export interface IFindByDescriptionVehicleOwnersParameters
  extends ICommandParameters {
  description: string;
  carrierUserId: string;
}

export interface IFindByDescriptionVehicleOwnersResponse
  extends OwnerDescriptionResponseDTO,
    ICommandResponse {}
